


















import { Vue, Prop, Component, Watch, Model } from 'vue-property-decorator'

import Icon from '@/components/base/iIcon.vue'

import TableHelper from './index'
import { TableDefine } from './type'
import utils from '@/libs/utils'

type OnSortParam = {
  key: string
  order: 'asc' | 'desc'
}

@Component({
  components: {
    Icon
  }
})
export default class OaTable<T> extends Vue {
  @Model('change')
  value?: T[]

  @Prop()
  readonly rowClassName?: (row: any, index: number) => String

  @Prop({
    default: () => {
    }
  })
  readonly onRowClick?: (row: any) => void

  @Prop()
  readonly tableDefine!: TableDefine<T>

  @Prop({ default: false })
  readonly loading?: boolean

  @Prop({ default: false })
  readonly editable?: boolean

  /**
   * 编辑模式下，如果是inputMode,
   * 表示变更自动触发双向绑定
   */
  @Prop({ default: false })
  readonly inputMode?: boolean

  @Prop({ default: false })
  readonly addNewAble?: boolean

  // 新增函数, 如果不设置，则默认添加一个空白数据在tableData
  @Prop({ default: undefined })
  readonly onAddNew?: (tableData: T[], next: Function) => {}

  @Prop({ default: () => [] })
  defaultSorts?: string[]

  @Prop()
  readonly sortAdapter?: ({ key, order }: OnSortParam) => OnSortParam

  editChanged: boolean = false
  sorts: string[] = []
  tableData: T[] = []
  tableHelper: TableHelper<T> | null = null

  @Watch('tableDefine')
  onWatchTableDefine () {
    this.tableHelper = new TableHelper<T>(this.tableDefine, this)
    this.tableHelper.bindRowEditEvent((index: number, newValue: T) => {
      this.tableData[index] = newValue
      this._onEditChange()
    })
  }

  @Watch('value')
  onWatchValue () {
    this.tableData = this.value ? utils.arrayClone(this.value) : []
  }

  get columns () {
    return this.tableHelper!.getTableCols()
  }

  created () {
    this.onWatchTableDefine()
    this.onWatchValue()
  }

  onSortChange (data: any) {
    let defaultSorts = this.defaultSorts || []
    this.sorts = []
    if (this.sortAdapter) {
      data = this.sortAdapter(data)
    }
    let { key, order } = data
    if (key !== undefined) {
      let sortKey = order === 'desc' ? `-${key}` : key
      let index = defaultSorts.indexOf(sortKey)
      if (index !== -1) {
        this.sorts = defaultSorts.splice(index, 1)
      }
      this.sorts.unshift(sortKey)
    }
    this.$emit('on-sort-change', this.sorts)
  }

  onCurRowClick (row: any, column: any, data: any, event: Event) {
    if (typeof this.onRowClick === 'function' &&
      column.type !== 'selection' && column.key !== 'action') {
      this.onRowClick(row)
    }
  }

  private _noEditModeError () {
    if (!this.editable) {
      this.$Message.error('该操作只能在编辑模式下使用')
      throw new Error('该操作只能在编辑模式下使用')
    }
    return true
  }

  _onAddNew () {
    if (this.onAddNew) {
      return this.onAddNew(this.tableData, () => {
        this._onEditChange()
      })
    }
    this.tableData.push({} as T)
    this._onEditChange()
  }

  public addNewCol (dataItem: T) {
    if (this._noEditModeError()) {
      this.tableData.push(dataItem)
      this._onEditChange()
    }
  }

  public updateCol (index:number, dataItem: T) {
    if (this._noEditModeError()) {
      this.$set(this.tableData, index, dataItem)
      this._onEditChange()
    }
  }

  public removeEditCol (index: number) {
    if (this._noEditModeError()) {
      utils.arrayRemove(this.tableData, index)
      this._onEditChange()
    }
  }

  public resetEditChange () {
    if (this._noEditModeError()) {
      this.tableData = utils.arrayClone(this.value || [])
    }
  }

  _validationtion (dataItem: any) {
    let valid = true
    let cellClass: Record<string, string> = {}
    for (let i = 0; i < this.columns.length; i++) {
      const column = this.columns[i]
      const required = column.required && typeof column.required === 'function'
        ? column.required(dataItem) : column.required
      if (required && (!(column.key! in dataItem) || !dataItem[column.key!])) {
        valid = false
        cellClass[column.key!] = 'od-table-error'
      }
    }
    this.$set(dataItem, 'cellClassName', cellClass)
    return valid
  }

  public validate () {
    let valid = true
    this.tableData.forEach(tableItem => {
      if (!this._validationtion(tableItem)) {
        valid = false
      }
    })
    return valid
  }

  private _onEditChange () {
    if (this.inputMode) {
      this.completeEditChange()
    } else {
      this.editChanged = true
    }
  }

  public completeEditChange () {
    if (this._noEditModeError()) {
      const valid = this.validate()
      if (!valid && !this.inputMode) {
        throw new Error('表格存在必填项未填写！')
      }
      this.$emit('change', this.tableData)
    }
  }
}
